module.exports = __webpack_public_path__ + "static/media/view-icon-diabetes.679d38d4.svg";